import React from 'react'

function AC_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp p-5'>
                    <div className='mt-5'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>10,000+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Aryan Sharma</h5>
                    <h6 class="font-weight-bold my-2">Chandigarh University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Good and knowledgeable sessions.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Aditya Kumar</h5>
                    <h6 class="font-weight-bold my-2">Noida International University, (BCA)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The internship program went really well and it was really good. The mentors were really good and knowledgeable. I fully satisfied and had a good experience with this Internship program with the Interns Elite.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Priya Arya</h5>
                    <h6 class="font-weight-bold my-2">Guru Nanak Dev University Regional Campus Gurdaspur</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>Conclusion is the way they guided us , its time taking but growth matters. Personally i am delighted to say  i had good experience.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Kushal Garg</h5>
                    <h6 class="font-weight-bold my-2">Delhi University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Experience with the team internsilite was very amazing, Every session with the mentor teaches a new thing and valuable point .
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Manisha Tejbahadur Kurmi</h5>
                    <h6 class="font-weight-bold my-2">Shivajirao s. Jondhale College of Engineering</h6>
                    <h6 class="font-weight-bold my-2">Delhi University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Teacher is very helping and they have a lot of knowledge about autocad. They are trying to clear every single doubt of student. 
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Abhijeet singh Rawat</h5>
                    <h6 class="font-weight-bold my-2">Graphic Era Hill University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I feel glad to get such a huge amount of knowledge and got to learn so many things which are new for me and give such a wonderful experience for my whole upcoming life.. thank u and i fell pleasure to be the part of this program.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default AC_Review_Program_Page
